import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Text,
  HStack,
  VStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Badge,
  Center,
  Input,
  GridItem,
  Checkbox,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { projectInformation } from "../forms";
import StepHeader from "../../../../../../components/StepperHeader";
import FormInput from "../../../../../../components/input";
import { color } from "../../../../../../utils/theme";
import {
  AddIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  DeleteIcon,
} from "@chakra-ui/icons";
import { Option } from "../../../../../../utils/types/props.dropdown";
import AppDrawer from "../../../../../../components/drawer";
import {
  getFormData,
  saveFormData,
} from "../../../../../../redux/slice/formSlice";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../../../redux/store";
import { RootState } from "../../../../../../redux/reducer/rootReducer";
import { StepProps } from "../../../../../../utils/types/step";
import {
  fetchDepartments,
  fetchTechnicalArea,
} from "../../../../../../redux/action";
import { SubDepartment } from "../../../../../../redux/reducer/departmentReducer";

const ProjectInformation = (props: StepProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const [fullName, setFullName] = useState("");
  const [viewTeamMembers, setViewTeamMembers] = useState(false);
  const [addTeamMemberLoading, setAddTeamMemberLoading] = useState(false);
  const dispatch: AppDispatch = useDispatch();

  const [role, setRole] = useState("");
  const [selectedMainDepartment, setSelectedMainDepartment] = useState<
    Option[]
  >([]);
  const [selectedSpecialityDepartment, setSelectedSpecialityDepartment] =
    useState("");
  const [showOtherSubDepartment, setShowOtherSubDepartment] = useState(false);
  const [showOtherDepartment, setShowOtherDepartment] = useState(false);
  const [showSubDepartmentSelection, setShowSubDepartmentSelection] =
    useState(false);
  const [subDepartments, setSubDepartments] = useState<Option[]>([]);
  let defaultMainDepartments = [
    {
      label: "OPD",
      value: "OPD",
    },
    {
      label: "IPD",
      value: "IPD",
    },
    {
      label: "ED",
      value: "ED",
    }
  ];
  const raw_departments = useSelector(
    (state: RootState) => state.department.data
  );
  const [mainDepartments, setMainDepartments] = useState<Option[]>(
    defaultMainDepartments
  );
  const [teamMembersError, setTeamMembersError] = useState(false);
  const [teamMembersErrorMessage, setTeamMembersErrorMessage] = useState("");
  const stepData = useSelector((state: RootState) => getFormData(state, "1"));
  const [saveAndExist, setSaveAndExist] = useState(false);
  const [teamMembers, setTeamMembers] = useState<
    {
      fullName: string;
      role: string;
    }[]
  >(stepData.teamMembers || []);
  const [technicalAreas, setTechnicalAreas] = useState<Option[]>([
    { label: "Technical Area 1", value: "Technical Area 1" },
    { label: "Technical Area 2", value: "Technical Area 2" },
  ]);
  const [specialityDepartments, setSpecialityDepartments] = useState<
    { label: string; value: string; sub_department: SubDepartment[] }[]
  >([]);

  const technicalArea = useSelector(
    (state: RootState) => state.technicalArea.data
  );

  useEffect(() => {
    setTechnicalAreas(
      technicalArea.map((area) => ({
        label: area.name,
        value: area.id.toString(),
      }))
    );
    setSpecialityDepartments([
      ...raw_departments.map((department) => ({
        label: department.name,
        value: department.id.toString(),
        sub_department: department.sub_departments,
      })),
      { label: "Other", value: "other_department", sub_department: [] },
    ]);
  }, [technicalArea, specialityDepartments]);

  useEffect(() => {
    dispatch(fetchTechnicalArea());
    dispatch(fetchDepartments());
  }, [dispatch]);

  const formik = useFormik({
    ...projectInformation,
    initialValues: stepData,
    onSubmit: (values) => {
      if (teamMembers.length < 1 || teamMembers.length > 2) {
        setTeamMembersError(true);
        setTeamMembersErrorMessage("Team members should be between 6 and 8.");
        return;
      } else {
        dispatch(saveFormData({ step: "1", data: values }));

        setTeamMembersError(false);
        if (!saveAndExist) {
          props.onNext();
        } else {
          setTimeout(() => {
            if (props.onSave) props.onSave();
          }, 2000);
        }
      }
    },
  });

  const [roles] = useState<Option[]>([
    {
      label: "Role 1",
      value: "role1",
    },
    {
      label: "Role 2",
      value: "role2",
    },
    {
      label: "Role 3",
      value: "role3",
    },
  ]);

  const handleCheckboxChange = (departmentValue: string) => {
    setSelectedMainDepartment((prevSelected: any) => {
      const isSelected = prevSelected.some(
        (dept: Option) => dept.value === departmentValue
      );
      if (isSelected) {
        return prevSelected.filter(
          (dept: Option) => dept.value !== departmentValue
        );
      } else {
        const departmentToAdd = mainDepartments.find(
          (dept) => dept.value === departmentValue
        );
        return [...prevSelected, departmentToAdd];
      }
    });
    formik.setFieldValue(
      "department",
      selectedMainDepartment.map((dept) => dept.value)
    );
  };

  return (
    <VStack h="100%" w="100%" spacing={4}>
      {/* Step Header */}
      <StepHeader
        title="Step 1: Project Information"
        description="Provide essential details about the project and team members."
        showInfo={false}
      />
      {viewTeamMembers && (
        <AppDrawer
          placement="right"
          title="Project Team Members"
          size="md"
          children={
            <VStack spacing={4}>
              <HStack
                w="95%"
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignSelf={"flex-start"}
              >
                <Text
                  fontSize={16}
                  pl={4}
                  fontWeight={"700"}
                  color={color.text}
                >
                  Full Name
                </Text>

                <Text
                  fontSize={16}
                  fontWeight={"700"}
                  color={color.text}
                  marginRight={10}
                >
                  Role
                </Text>
              </HStack>
              {teamMembers.map((member, index) => (
                <HStack
                  key={`${member.fullName}-${index}`}
                  w="full"
                  p={4}
                  bg="gray.50"
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  gap={4}
                >
                  <Text fontSize={18} fontWeight={"500"} color={color.text}>
                    {member.fullName}
                  </Text>
                  <HStack gap={5}>
                    <Text fontSize={16} color={color.text}>
                      {member.role}
                    </Text>
                    <DeleteIcon
                      color={"red.500"}
                      bg={"gray.200"}
                      p={1}
                      borderRadius={5}
                      fontSize={27}
                      onClick={() => {
                        setTeamMembers(
                          teamMembers.filter((_, i) => i !== index)
                        );
                      }}
                    />
                  </HStack>
                </HStack>
              ))}
            </VStack>
          }
          onClose={() => setViewTeamMembers(false)}
        />
      )}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Team Member</ModalHeader>
          <ModalCloseButton />
          <ModalBody sx={{ display: "flex", gap: 3, flexDirection: "column" }}>
            <>
              <FormInput
                name="fullName"
                isRequired={true}
                value={fullName}
                label="Full Name"
                type="text"
                id="fullName"
                errorMessage={fullName === "" ? "Full Name is required" : ""}
                onChange={(event) => {
                  setFullName(event.target.value);
                }}
              />
            </>
            <>
              <FormLabel
                alignSelf={"flex-start"}
                display={"flex"}
                mb={-4}
                pb={0}
                justifyContent={"left"}
                alignContent={"flex-start"}
                alignItems={"flex-start"}
                textAlign={"left"}
                fontWeight={"500"}
                color={"black"}
              >
                Role
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>
              <Select
                placeholder="Select Role"
                onChange={(event) => {
                  setRole(event.target.value);
                }}
                mt={0}
                pt={0}
              >
                {roles.map((role, index) => (
                  <option key={`${role}-${index}`} value={role.value}>
                    {role.label}
                  </option>
                ))}
              </Select>
              {role === "" && (
                <Text mt={2} color="red.500" fontSize="sm">
                  Role is required.
                </Text>
              )}
            </>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              isLoading={addTeamMemberLoading}
              isDisabled={role === "" || fullName === ""}
              onClick={async () => {
                formik.setFieldValue("teamMembers", [
                  ...teamMembers,
                  { fullName, role },
                ]);
                setTeamMembers([...teamMembers, { fullName, role }]);
                setRole("");
                setFullName("");
                onClose();
              }}
              w={"100%"}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Form Section */}
      <Box w="full" p={4} flex={1}>
        <form onSubmit={formik.handleSubmit}>
          <Flex direction="column" gap={6}>
            {/* Team Members Section */}
            <FormControl
              style={{ width: "100%" }}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignContent={"center"}
              alignItems={"center"}
              background={"gray.50"}
              borderColor={teamMembersError ? "red" : "gray.200"}
              borderWidth={0.5}
              py={4}
              px={2}
            >
              <FormLabel
                display={"flex"}
                mb={0}
                fontSize={18}
                fontWeight={"500"}
                color={color.text}
              >
                Team Members
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>
              <HStack>
                <Button
                  colorScheme="blue"
                  size={"sm"}
                  leftIcon={<AddIcon />}
                  onClick={onOpen}
                >
                  Add Team Member
                </Button>
                {teamMembers.length > 0 && (
                  <Button
                    colorScheme="blue"
                    variant={"outline"}
                    size={"sm"}
                    rightIcon={
                      <Badge ml="1" colorScheme="green">
                        {teamMembers.length}
                      </Badge>
                    }
                    onClick={() => setViewTeamMembers(true)}
                  >
                    View Added Members
                  </Button>
                )}
              </HStack>
            </FormControl>
            {teamMembersError && (
              <Text color={"red"} textAlign="left" fontWeight={"normal"}>
                {teamMembersErrorMessage}
              </Text>
            )}
            {/* Project Information */}
            <FormInput
              name="name"
              isRequired={true}
              value={formik.values.name}
              label="Project Name"
              type="text"
              id="name"
              errorMessage={formik.errors.name as string}
              onChange={(event) => {
                formik.setFieldValue("name", event.target.value);
              }}
            />

            <FormInput
              name="sponsor"
              isRequired={true}
              value={formik.values.sponsor}
              label="Sponsor"
              type="text"
              id="sponsor"
              errorMessage={formik.errors.sponsor as string}
              onChange={(event) => {
                formik.setFieldValue("sponsor", event.target.value);
              }}
              onBlur={formik.handleBlur}
            />

            <HStack width={"100%"} gap={4}>
              <FormControl
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: "normal",
                }}
              >
                <FormLabel
                  display={"flex"}
                  mb={0}
                  fontWeight={"500"}
                  color={color.text}
                >
                  Specialty Department
                  <Text color={"red"} mx={1} fontSize={24}>
                    *
                  </Text>
                </FormLabel>
                <ReactSelect
                  placeholder=""
                  options={specialityDepartments}
                  onChange={(event) => {
                    console.log("event: ", event);

                    if (event?.value === "other_department") {
                      setShowOtherDepartment(true);
                      setShowSubDepartmentSelection(false);
                    } else {
                      setShowOtherDepartment(false);
                      if ((event?.sub_department?.length as number) > 0) {
                        console.log(
                          "event?.sub_department: ",
                          event?.sub_department
                        );

                        setShowSubDepartmentSelection(true);
                        let subDepartments = event?.sub_department.map(
                          (sub) => ({
                            label: sub?.name,
                            value: sub?.id.toString(),
                          })
                        );
                        setSubDepartments([
                          ...(subDepartments as Option[]),
                          { label: "Other", value: "other_sub_department" },
                        ]);
                      } else {
                        setShowSubDepartmentSelection(false);
                      }
                      if (event?.label === "Pediatrics") {
                        const updatedMainDepartments = mainDepartments.filter(
                          (department) => department.value !== "ICU"
                        );
                        console.log(
                          "updatedMainDepartments: ",
                          updatedMainDepartments
                        );
                        setMainDepartments(updatedMainDepartments);
                      } else {
                        setMainDepartments(defaultMainDepartments);
                      }
                      setSelectedSpecialityDepartment(event?.label as string);
                      formik.setFieldValue("specialtyDepartment", event?.value);
                      setSelectedMainDepartment([]);
                    }
                  }}
                />

                <Text
                  marginY={3}
                  fontWeight={"normal"}
                  color={"red"}
                  fontSize={13}
                >
                  {formik.errors.specialtyDepartment as string}
                </Text>
              </FormControl>

              <FormControl
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: "normal",
                }}
              >
                <FormLabel
                  display={"flex"}
                  mb={0}
                  fontWeight={"500"}
                  color={color.text}
                >
                  Sub Specialty Department
                  <Text color={"red"} mx={1} fontSize={24}>
                    *
                  </Text>
                </FormLabel>
                <ReactSelect
                  placeholder=""
                  options={subDepartments}
                  onChange={(event) => {
                    if (event?.value === "other_sub_department") {
                      setShowOtherSubDepartment(true);
                    } else {
                      setShowOtherSubDepartment(false);
                      formik.setFieldValue("technicalArea", event?.value);
                    }
                  }}
                />

                <Text
                  marginY={3}
                  fontWeight={"normal"}
                  color={"red"}
                  fontSize={13}
                >
                  {formik.errors.technicalArea as string}
                </Text>
              </FormControl>
              {showOtherDepartment ||
                (showOtherSubDepartment && (
                  <Center w={"100%"}>
                    {showOtherSubDepartment && (
                      <Input placeholder="Enter sub department" />
                    )}
                    {showOtherDepartment && (
                      <Input placeholder="Enter department" />
                    )}
                  </Center>
                ))}
            </HStack>

            <GridItem w="100%" textAlign={"left"} fontWeight={"normal"} mb={5}>
              <VStack textAlign={"left"} w={"95%"}>
                <FormLabel
                  color={color.text}
                  display={"flex"}
                  mb={0}
                  fontSize={16}
                  textAlign={"left"}
                  justifyContent={"left"}
                  alignContent={"flex-start"}
                  w={"100%"}
                >
                  Department
                  <Text color={"red"} mx={1} fontSize={24}>
                    *
                  </Text>
                  <Text fontWeight={"normal"} color={"red"} fontSize={13}>
                    {formik.errors.department as string}
                  </Text>
                </FormLabel>
                <HStack
                  mt={-2}
                  pt={0}
                  gap={10}
                  width={"100%"}
                  justifyContent="flex-start"
                  borderRadius={2}
                >
                  {mainDepartments.map((department, index) => (
                    <Checkbox
                      key={index}
                      value={department.value}
                      isChecked={selectedMainDepartment.some(
                        (selected) => selected.value === department.value
                      )}
                      disabled={
                        selectedSpecialityDepartment === "Emergency Medicine" ||
                        selectedSpecialityDepartment === "Radiology" ||
                        selectedSpecialityDepartment === "Anesthesiology" ||
                        selectedSpecialityDepartment === "Pathology" ||
                        selectedSpecialityDepartment === "Other"
                          ? true
                          : false
                      }
                      onChange={() => handleCheckboxChange(department.value)}
                      color={color.text}
                      fontWeight={500}
                    >
                      {department.label}
                    </Checkbox>
                  ))}
                </HStack>
              </VStack>
            </GridItem>

            {/* Dates */}
            <HStack spacing={4}>
              <FormInput
                id="startDate"
                name="startDate"
                isRequired={true}
                value={formik.values.startDate}
                label="Start Date"
                type="date"
                errorMessage={formik.errors.startDate as string}
                onChange={(event) => {
                  formik.setFieldValue("startDate", event.target.value);
                }}
                onBlur={formik.handleBlur}
              />
              <FormInput
                id="lastRevised"
                name="lastRevised"
                isRequired={true}
                value={formik.values.lastRevised}
                label="Last Revised"
                type="date"
                errorMessage={formik.errors.lastRevised as string}
                onChange={(event) => {
                  formik.setFieldValue("lastRevised", event.target.value);
                }}
                onBlur={formik.handleBlur}
              />
            </HStack>
          </Flex>
        </form>
      </Box>

      {/* Divider */}
      <Divider h={0.2} bg={color.primary} />

      {/* Footer Buttons */}
      <HStack
        flex={0.1}
        w="100%"
        justifyContent="space-between"
        p={4}
        bg="gray.50"
      >
        <Button
          colorScheme="blue"
          variant="outline"
          leftIcon={<ArrowLeftIcon />}
          onClick={props.onPrev}
        >
          Previous
        </Button>
        <HStack>
          <Button
            colorScheme="blue"
            isDisabled={!formik.isValid}
            variant="outline"
            onClick={() => {
              setSaveAndExist(true);
              formik.handleSubmit();
              console.log("Saved values:", formik.values);
            }}
          >
            Save & Exit
          </Button>
          <Button
            colorScheme="blue"
            onClick={() => {
              setSaveAndExist(false);
              console.log("Form values:", formik.values);
              console.log("Form errors:", formik.errors);

              formik.handleSubmit();
            }}
            w={"50%"}
            rightIcon={<ArrowRightIcon />}
          >
            Next
          </Button>
        </HStack>
      </HStack>
    </VStack>
  );
};

export default ProjectInformation;
